export default {
    index: {
        title: '학생 목록',
        register: '학생 등록',
        update: '학생 정보 수정',
        search: {
            title: '학생 이름 검색',
        },
        view: {
            list: '리스트 스타일',
            grid: '그리드 스타일',
        },
        emptyMessage: '등록된 학생이 없습니다.',
        buttons: {
            edit: '정보 수정',
            delete: '삭제',
        },
        classroomNumber: '출석 번호',
        pinNumber: '핀 번호',
        delete: '학생 삭제',
        deleteConfirm: '정말 삭제하시겠어요?',
        remainCount: '남은 인원은 {count}명입니다.\n등록하시겠습니까?',

        remainCountShort: '학생 등록 (남은 인원: {count}명)',
        placeholder: {
            classroomNumber: '출석번호',
            name: '한글 2~6자',
            pinNumber: '0000',
        },
        table: {
            classroomNumber: '출석 번호',
            name: '이름',
            pinNumber: 'PIN 번호',
            champion: '챔피언',
            mvp: 'MVP',
            stars: '칭찬별',
            total: '누적별',
            achievement: '성취도',
        },
        pasteRegister: {
            title: '일괄 등록',
            guide: '엑셀에서 학생 목록을 복사하여 아래에 붙여넣기 해주세요.',
            placeholder: '번호\t이름\t핀번호\n1\t홍길동\t1234\n2\t고희동\t5678',
            notice: '※ 출석번호는 기존 학생과 중복될 수 없습니다.',
            checkData: '데이터 확인',
            emptyData: '붙여넣기 된 데이터가 없습니다.',
            summaryTotal: '총 {total}명 확인 완료.',
            summaryError: '(오류 {error}건 포함)',
            registerAll: '전체 등록',
            registerValid: '오류 제외 등록 ({count}명)',
            statusOk: '정상',
            statusMissingNumber: '출석번호 누락/오류',
            statusDuplicateExisting: '기존 등록 번호와 중복',
            statusDuplicateInput: '입력 데이터 내 중복 번호',
            statusInvalidName: '이름 형식 오류',
            statusInvalidPin: '핀번호 형식 오류',
            statusOverLimit: '등록 가능 인원 초과',
            no: 'No',
            back: '뒤로',
        },
    },
    detail: {
        info: {
            studentList: '학생 목록',
            detailInfo: '상세 정보',
            title: '학생 정보',
            data: {
                pinNumber: '핀 번호',
                phoneNumber: '폰 번호',
            },
        },
        learnArea: {
            title: '영역별 학습 현황',
            tabs: {
                total: '전체',
                vocabulary: '어휘',
                writing: '쓰기',
                grammar: '문법',
                comprehension: '이해/추론',
                reading_speaking: '읽기/말하기',
            },
        },
        achievements: {
            title: '학습 성취도',
            empty: {
                message: '아직 수업 데이터가 없어요',
                instruction: '첫 수업을 진행하면\n 학습 성취도를 확인할 수 있어요',
            },
            basedOn: '최근 {count}개 수업',
            basedOnAll: '전체',
            stats: {
                classCount: '수업 수',
                activityCount: '활동 수',
            },
        },
        memo: {
            title: '교사 메모',
            placeholder: '학생 관찰 내용이나 상담 시 전달사항을 자유롭게 기록하세요.',
            savedMemo: '저장된 메모',
            deleteMemo: '메모 삭제',
            confirmDeleteMemo: '정말 메모를 삭제하시겠습니까?',
            deletedMemoMessage: '메모가 삭제되었습니다.',
        },
        activityHistory: {
            title: '학습 활동 기록',
            activitySelect: '활동 선택',
            previousRecord: '이전 기록 더보기',
            moreRecord: '{count}개 남음',
            startDateError: '시작일을 올바른 날짜로 입력해주세요.',
            endDateError: '종료일을 올바른 날짜로 입력해주세요.',
            empty: {
                class: {
                    title: '진행한 학습이 없어요',
                    subtitle: '수업을 진행하면 기록이 이곳에 표시됩니다',
                },
                activity: {
                    title: '진행한 학습이 없어요',
                    subtitle: '활동을 진행하면 기록이 이곳에 표시됩니다',
                },
            },
        },
    },
};
